import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { fakturniaAnimations } from '@fakturnia/animations';
import { FakturniaNavigationService } from '@fakturnia/components/navigation/navigation.service';
import { FakturniaNavigationItem } from '@fakturnia/components/navigation/navigation.types';
// import { FakturniaUtilsService } from '@fakturnia/services/utils/utils.service';
import { ReplaySubject, Subject } from 'rxjs';
import { FakturniaHorizontalNavigationBasicItemComponent } from './components/basic/basic.component';
import { FakturniaHorizontalNavigationBranchItemComponent } from './components/branch/branch.component';
import { FakturniaHorizontalNavigationSpacerItemComponent } from './components/spacer/spacer.component';
import { FakturniaUtilsService } from '@fakturnia/services/utils/utils.service';

@Component({
    selector       : 'fakturnia-horizontal-navigation',
    templateUrl    : './horizontal.component.html',
    styleUrls      : ['./horizontal.component.scss'],
    animations     : fakturniaAnimations,
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'fakturniaHorizontalNavigation',
    standalone     : true,
    imports        : [NgFor, NgIf, FakturniaHorizontalNavigationBasicItemComponent, FakturniaHorizontalNavigationBranchItemComponent, FakturniaHorizontalNavigationSpacerItemComponent],
})
export class FakturniaHorizontalNavigationComponent implements OnChanges, OnInit, OnDestroy
{
    @Input() name: string = this._fakturniaUtilsService.randomId();
    @Input() navigation: FakturniaNavigationItem[];

    onRefreshed: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fakturniaNavigationService: FakturniaNavigationService,
        private _fakturniaUtilsService: FakturniaUtilsService,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On changes
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void
    {
        // Navigation
        if ( 'navigation' in changes )
        {
            // Mark for check
            this._changeDetectorRef.markForCheck();
        }
    }

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Make sure the name input is not an empty string
        // if ( this.name === '' )
        // {
        //     this.name = this._fakturniaUtilsService.randomId();
        // }

        // Register the navigation component
        this._fakturniaNavigationService.registerComponent(this.name, this);
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Deregister the navigation component from the registry
        this._fakturniaNavigationService.deregisterComponent(this.name);

        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Refresh the component to apply the changes
     */
    refresh(): void
    {
        // Mark for check
        this._changeDetectorRef.markForCheck();

        // Execute the observable
        this.onRefreshed.next(true);
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any
    {
        return item.id || index;
    }
}
